"use client";
import { j as n } from "./jsx-runtime-CJ-St4mQ.mjs";
import { createContext as i, useContext as s } from "react";
const t = i(
  void 0
), d = () => {
  const o = s(t);
  if (!o)
    throw new Error("Radio components must be used within a RadioGroup");
  return o;
}, p = ({
  children: o,
  variant: e = "default",
  variantOptionLabel: r = "alphabet"
}) => /* @__PURE__ */ n.jsx(t.Provider, { value: { variant: e, variantOptionLabel: r }, children: o });
export {
  p as RadioGroupProvider,
  d as useRadioGroupContext
};
